<input
  class="autocomplete"
  name="deviceLocation"
  id="deviceLocation"
  type="text"
  [disabled]="disabled"
  [required]="required"
  [(ngModel)]="value"
  matInput
  [placeholder]="placeholder">
